module.exports = __webpack_public_path__ + "static/assets/24b564be24fc41c34db3562ac3859132.png";